import React, {Component, useState} from 'react';

import {
    ButtonSet, Button, TextInput
} from "carbon-components-react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import data from "../../data";

export default class extends Component {

    state = {
        form: {
            modal_create: false,
            id: "",
            user: ""
        }
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        let {form} = this.props;
        this.setState({
            form: {
                modal_create: form.modal_create,
                user: form.user,
                id: form.id,
            }
        })
    }

    handleSubmit = async (e) => {
        this.props.onSubmitForm(this.state.form);
    }

    handleCloseModal = async (e) => {
        this.setState(prevState => ({
            form: {...prevState.form, modal_create: false}
        }));
        this.props.onCloseModal(this.state.form);
    }


    handleChange = e => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {...prevState.form, [name]: value}
        }));
    };

    render() {

        return (
            <>
                <Dialog open={this.state.form.modal_create} onClose={(e) => this.handleCloseModal(e)}
                        aria-labelledby="form-dialog-title"
                        fullWidth={true}>
                    <DialogTitle id="form-dialog-title"><span
                        style={{color: "#000"}}>Criar usuário</span>
                    </DialogTitle>
                    <DialogContent style={{paddingBottom: "50px"}}>
                        <p>Para gerar um novo usuário, preencha os dados abaixo e confirme</p>
                        <TextInput
                            type="email"
                            required
                            id="user"
                            name="user"
                            labelText="E-mail"
                            onChange={this.handleChange}
                            placeholder={"E-mail do novo usuário"}
                            value={this.state.form.user}

                        />
                    </DialogContent>
                    <DialogActions style={{padding: "0px"}}>
                        <div style={{width: "100%"}}>
                            <Button style={{width: "50%"}} kind="secondary" onClick={(e) => this.handleCloseModal(e)} isExpressive>
                               Cancelar
                            </Button>
                            <Button style={{width: "50%"}} kind="primary" onClick={(e) => this.handleSubmit(e)} isExpressive>
                                Confirmar
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
